"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EXPECTED_BIOMETRIC_DISENROLL_REASONS = exports.BiometricDisenrollReason = exports.BiometricsError = exports.AuthPermission = exports.AvenMyNextAction = void 0;
/** Next action after inputting phone number in Aven My */
var AvenMyNextAction;
(function (AvenMyNextAction) {
    AvenMyNextAction["CH_PORTAL"] = "CH_PORTAL";
    AvenMyNextAction["CH_PORTAL_SET_PASSWORD"] = "CH_PORTAL_SET_PASSWORD";
    AvenMyNextAction["INVALID_PHONE_NUMBER"] = "INVALID_PHONE_NUMBER";
    AvenMyNextAction["HOME_OG_FLOW"] = "HOME_OG_FLOW";
    /** If deepLink url is for redeeming group cardholder rewards but the user does not have an account */
    AvenMyNextAction["GROUP_CARDHOLDER_REWARDS_INTERSTITIAL"] = "GROUP_CARDHOLDER_REWARDS_INTERSTITIAL";
})(AvenMyNextAction || (exports.AvenMyNextAction = AvenMyNextAction = {}));
var AuthPermission;
(function (AuthPermission) {
    AuthPermission["generateJwt"] = "generateJwt";
})(AuthPermission || (exports.AuthPermission = AuthPermission = {}));
var BiometricsError;
(function (BiometricsError) {
    BiometricsError["cancelledByUser"] = "cancelledByUser";
    BiometricsError["noPermission"] = "noPermission";
    BiometricsError["noCredentialsFound"] = "noCredentialsFound";
    BiometricsError["platFormError"] = "platFormError";
    BiometricsError["invalidSavedCredentials"] = "invalidSavedCredentials";
})(BiometricsError || (exports.BiometricsError = BiometricsError = {}));
/**
 * The reason we cleared (disenrolled) a device's biometric enrollment. Emitted on the
 * eventBiometricDisenrolled analytics event so the disenroll monitor runners can track disenroll volume by
 * reason and tell an unexpected disenroll apart from an expected one.
 *
 * EVERY path that clears enrollment must emit this event with a reason. The runners treat a re-enrollment
 * with no preceding disenroll event as a bug (enrollment cleared through an un-instrumented path), so a
 * silent disenroll shows up as a false page. Transient failures (network blip while refreshing the access
 * token, platform hiccup, timeout, user cancel) must not disenroll at all, so they get no reason here.
 *
 * Source of truth for these string values. The native apps mirror this enum (they cannot import TS):
 *   - aven_android: com.aven.analytics ... BiometricDisenrollReason
 *   - aven_ios: BiometricDisenrollReason (AvenAnalytics.swift)
 * Keep all three in sync.
 */
var BiometricDisenrollReason;
(function (BiometricDisenrollReason) {
    BiometricDisenrollReason["keystoreKeyInvalidated"] = "keystoreKeyInvalidated";
    BiometricDisenrollReason["storedCredentialsNotFound"] = "storedCredentialsNotFound";
    BiometricDisenrollReason["decryptionFailed"] = "decryptionFailed";
    BiometricDisenrollReason["storedCredentialsRejected"] = "storedCredentialsRejected";
    BiometricDisenrollReason["userLogout"] = "userLogout";
    BiometricDisenrollReason["userDisabledBiometrics"] = "userDisabledBiometrics";
    BiometricDisenrollReason["passcodeReset"] = "passcodeReset";
    BiometricDisenrollReason["storedDataVersionOutdated"] = "storedDataVersionOutdated";
})(BiometricDisenrollReason || (exports.BiometricDisenrollReason = BiometricDisenrollReason = {}));
// The subset of reasons that are working-as-intended. Runners that page on a disenroll must exclude these; see
// unexpectedDisenrollReasonSql in aven_backend/src/runners/utils/biometricRunnerUtil.ts.
exports.EXPECTED_BIOMETRIC_DISENROLL_REASONS = [
    BiometricDisenrollReason.userLogout,
    BiometricDisenrollReason.userDisabledBiometrics,
    BiometricDisenrollReason.passcodeReset,
    BiometricDisenrollReason.storedDataVersionOutdated,
];
